import React from "react";
import { useNavigate } from "react-router";
import ThemeToggle from "./commonComponents/ThemeToggle";
import profileIcon from '../assets/userProfileIcon.png'
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { persistor } from "../store";
import { logout } from "../slices/authSlice";

import profileFeedback from '../assets/navbar/profileFeedback.png'
import profileHelp from '../assets/navbar/profileHelp.png'
import profileReset from '../assets/navbar/profileReset.png'
import profileLogout from '../assets/navbar/profileLogout.png'


const Navbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.auth.userData);

  const handleSignOut = () => {
    persistor.purge();
    dispatch(logout())
    navigate("/");
  };

  return (
    <Box>
      <div className="navbarLeft">
        <h1 onClick={() => navigate("/")}>
          Brain Quiz <span>•</span>
        </h1>
      </div>

      <div className="navbarRight">
        <span className="themeBox"><ThemeToggle /></span>
        <img src={profileIcon} className="profileIcon" />

        <div class="dropdown" id="dropdown">
          <span className="titleText span" style={{ marginBottom: '0rem', border: 'none' }} onClick={() => navigate('/profile')}>Signed In as <b>{userData?.user?.fullName}</b></span>
          <span onClick={() => navigate('/feedback')} className="span"><img src={profileFeedback} /> Feedback</span>
          <span onClick={() => navigate('/support')} className="span"><img src={profileHelp} /> Help</span>
          <span onClick={() => navigate('/reset')} className="span"><img src={profileReset} /> Reset Password</span>
          <span onClick={handleSignOut} className="span"><img src={profileLogout} /> Logout</span>
        </div>
      </div>
    </Box>
  );
};

export default Navbar;

const Box = styled.div`
  max-width: 100%;
  width: 100%;
  height: 70px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  background-color: var(--background-color);
  opacity: 0.95;
  box-shadow: 0 0 3px var(--color);
  z-index: 1000;

.navbarLeft {
  margin-left: 3vw;
}

.navbarLeft h1 {
  font-size: 4rem;
  cursor: pointer;
}

.navbarLeft h1 span {
  color: var(--orange);
  font-size: 4rem;
  margin-left: -3px;
}

.navbarRight {
  margin-right: 2vw;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 3rem;

  .themeBox {
    height: 50%;
    display: flex;
    align-items: center;
    margin-top: 2rem;
  }

  .profileIcon {
    height: 50%;
    cursor: pointer;
    position: relative;
  }

  .dropdown {
    display: none;
    position: absolute;
    top: 75%;
    right: 1%;
    background-color: var(--background-color);
    border: 0.1rem solid var(--color);
    padding: 2rem;
    font-weight: 400;
    font-size: 1.5rem;
    border-radius: 0.75rem;

    .titleText {
      font-weight: 400;
      font-size: 1.75rem;
    }

    img {
      width: 1.75rem;
      background-color: var(--white);
      padding: 0.5rem;
      border-radius: 1rem;
    }
}

.dropdown .span {
    display: flex;
    padding: 8px 10px;
    text-decoration: none;
    color: var(--color);
    transition: background-color 0.3s ease;
    border-bottom: 0.1rem solid var(--color);
    gap: 1rem;
    align-items: center;
}

.dropdown .span:hover {
    background-color: var(--color);
    color: var(--background-color);
    border-radius: 5px;
    cursor: pointer;
}

.profileIcon:hover+#dropdown {
    display: block;
}

.dropdown:hover {
    display: block;
}
}

@media (max-width: 420px) {
  .navbarLeft h1 {
    font-size: 5rem;
  }

  .navbarLeft h1 span {
    font-size: 5rem;
  }
}


`

